'use client';

import { TextInput } from '@mantine/core';
import React from 'react';
import { Button } from '../../ui/Button';

interface InputMultipleProps {
  defaultValue: (string | undefined)[];
  onChange: (items: (string | undefined)[]) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

function InputMultiple({
  defaultValue,
  onChange,
  className,
  disabled,
  ...props
}: InputMultipleProps) {
  if (defaultValue.length == 0) defaultValue = [undefined];
  const [items, setItems] =
    React.useState<(string | undefined)[]>(defaultValue);

  return (
    <div className="col-span-12">
      {items != undefined &&
        items.map((item, index) => (
          <div className="w-full mb-2" key={index}>
            <TextInput
              className="mt-4 mb-4"
              placeholder={props.placeholder}
              disabled={disabled}
              onBlur={(
                event: { target: { value: string | undefined } } | undefined
              ) => {
                if (event != undefined && items.length > index) {
                  items[index] = event.target.value;
                  setItems(items);
                  onChange(items);
                }
              }}
              defaultValue={item}
            />
            {index == items.length - 1 && !disabled && (
              <div className="col-span-2 ml-2">
                <div className="mb-4">
                  <Button
                    onClick={() => {
                      if (items.length > 1) {
                        setItems(items.slice(0, items.length - 1));
                        onChange(items);
                      }
                    }}
                    text={'- Remove'}
                    variant={'secondary'}
                  ></Button>
                </div>
                <Button
                  onClick={() => {
                    setItems([...items, undefined]);
                    onChange(items);
                  }}
                  text={'+ Add'}
                  variant={'secondary'}
                ></Button>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

export { InputMultiple };
